import React from 'react';
import { BaseModal } from './BaseModal';
import { ImageZoom } from './ImageZoom';

interface CollectionPointInfoModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function CollectionPointInfoModal({ isOpen, onClose }: CollectionPointInfoModalProps) {
  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      title="How This Collection Point Works"
      size="large"
    >
      <div className="space-y-6 text-gray-600 dark:text-gray-300">
        {/* Section 1: API-Based Collection Point */}
        <div>
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">1. API-Based Collection Point</h3>
          <div className="bg-gray-50 dark:bg-gray-700 p-4 rounded-lg">
            <p className="mb-4">
              This form leverages OneTrust's API collection point to securely gather and process your information.
              All data is encrypted and transmitted directly to OneTrust's compliance platform.
            </p>
            <ImageZoom 
              src="https://kebgtyzuvrqfytplwpwa.supabase.co/storage/v1/object/sign/website-images/GET%20IN%20TOUCH%20OT%20FORM/OT%20GUY%20API%20Details%20for%20Get%20In%20Touch.png?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1cmwiOiJ3ZWJzaXRlLWltYWdlcy9HRVQgSU4gVE9VQ0ggT1QgRk9STS9PVCBHVVkgQVBJIERldGFpbHMgZm9yIEdldCBJbiBUb3VjaC5wbmciLCJpYXQiOjE3NDM2OTY2MjYsImV4cCI6MjA1OTA1NjYyNn0.69quQJDtnrflCwogiI6yCORPpKdFElSIK4ZN1TtWO4Q"
              alt="OneTrust API Configuration"
              className="w-full h-auto object-contain max-h-[400px] mx-auto"
            />
          </div>
        </div>

        {/* Section 2: Receipt Generation */}
        <div>
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">2. Automated Receipt Generation</h3>
          <div className="bg-gray-50 dark:bg-gray-700 p-4 rounded-lg">
            <p className="mb-4">
              Each submission automatically generates a unique receipt in OneTrust, ensuring proper tracking 
              and documentation of your interaction. This receipt contains all relevant metadata and consent records.
            </p>
            <ImageZoom 
              src="https://kebgtyzuvrqfytplwpwa.supabase.co/storage/v1/object/sign/website-images/GET%20IN%20TOUCH%20OT%20FORM/OT%20GUY%20Receipt%20Summary%20Get%20In%20Touch.png?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1cmwiOiJ3ZWJzaXRlLWltYWdlcy9HRVQgSU4gVE9VQ0ggT1QgRk9STS9PVCBHVVkgUmVjZWlwdCBTdW1tYXJ5IEdldCBJbiBUb3VjaC5wbmciLCJpYXQiOjE3NDM2OTY2NjQsImV4cCI6MjA1OTA1NjY2NH0.pPRao1vvHVS0FiLsr6MFf8NOLTkObKoUye8CuH7afCo"
              alt="OneTrust Receipt Example"
              className="w-full h-auto object-contain max-h-[400px] mx-auto"
            />
          </div>
        </div>

        {/* Section 3: Purpose-Based Consent */}
        <div>
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">3. Purpose-Based Consent</h3>
          <div className="bg-gray-50 dark:bg-gray-700 p-4 rounded-lg">
            <p className="mb-4">
              When you submit this form, an implicit consent record is created for specific communication purposes.
              This ensures compliance with privacy regulations while maintaining transparency about how your data will be used.
            </p>
            <ImageZoom 
              src="https://kebgtyzuvrqfytplwpwa.supabase.co/storage/v1/object/sign/website-images/GET%20IN%20TOUCH%20OT%20FORM/OT%20GUY%20Purpose%20Consent%20Get%20In%20Touch.png?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1cmwiOiJ3ZWJzaXRlLWltYWdlcy9HRVQgSU4gVE9VQ0ggT1QgRk9STS9PVCBHVVkgUHVycG9zZSBDb25zZW50IEdldCBJbiBUb3VjaC5wbmciLCJpYXQiOjE3NDM2OTcwMDQsImV4cCI6MjA1OTA1NzAwNH0.dum8F-HdavKAPR7eGszx0ANeVM840yHlJFMhUR7MV28"
              alt="OneTrust Purpose Configuration"
              className="w-full h-auto object-contain max-h-[400px] mx-auto"
            />
          </div>
        </div>

        <div className="mt-6 bg-blue-50 dark:bg-blue-900/20 p-4 rounded-lg">
          <p className="text-sm text-blue-800 dark:text-blue-200">
            All data processing is conducted in accordance with our privacy policy and applicable data protection regulations.
            You can manage your communication preferences at any time through our preference center.
          </p>
        </div>
      </div>
    </BaseModal>
  );
}